import { z } from "zod";
import { DocumentationItemHeaderV1, defaultDocumentationItemHeaderV1 } from "./item-header-v1";

export const DocumentationItemConfigurationV1 = z.object({
  showSidebar: z.boolean(),
  isPrivate: z.boolean().optional(),
  isHidden: z.boolean().optional(),
  header: DocumentationItemHeaderV1,
});

export type DocumentationItemConfigurationV1 = z.infer<typeof DocumentationItemConfigurationV1>;

export const defaultDocumentationItemConfigurationV1: DocumentationItemConfigurationV1 = {
  header: defaultDocumentationItemHeaderV1,
  showSidebar: true,
};
